import axios from '../base'
import { MyPermissions, PermissionsEnvelope } from './permissions.types'

// Capability resolver contract from acespace-backend#214 (product#618 Phase A).
// GET /locations/<id>/my-permissions returns the CALLER's resolved capability set
// for that location — the single source of truth for capability-based UI gating.
//
// The backend is authoritative (each gated route 403s on deny); this FE read is
// UX only, so it is deliberately FAIL-OPEN: any failure — a network error, or a
// 404 from an un-migrated backend that predates the endpoint — returns `null`,
// and callers treat an unknown capability as allowed (current behavior). The
// backend's default-deny is what actually protects the action.
export class PermissionsService {
  getMyPermissions = async (
    locationId: number | string
  ): Promise<MyPermissions | null> => {
    try {
      const { data } = await axios.get<PermissionsEnvelope<MyPermissions>>(
        `/locations/${locationId}/my-permissions`
      )
      if (data.error) return null
      return data.data
    } catch {
      // Fail-open: endpoint absent / network error → no capability info.
      return null
    }
  }
}

export default new PermissionsService()
